import "./WeeklySchedule.html";
import "./WeeklySchedule.scss";

import "../TimeRangePickerV2/TimeRangePickerComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import WeeklyScheduleComponentController from "./WeeklyScheduleComponentController";

export default class WeeklyScheduleComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            groupTypeName: "@",
            weeklySchedule: "=",
        };
        this.controller = WeeklyScheduleComponentController;
        this.templateUrl = "/App/Components/Forms/WeeklySchedule/WeeklySchedule.html";
    }
}

module("mmManagePortal").component("irWeeklySchedule", new WeeklyScheduleComponent());
